<template>
  <b-select
    :loading="isLoading"
    v-model="select_value"
    @input="$emit('update:value', select_value)"
    :disabled="disabled"
    required expanded>
    <option value="">{{ defaultValue }}</option>
    <option v-for="(label, key) in groups" :value="key" :key="key">{{ label }}</option>
  </b-select>
</template>

<script>
import API from '@/api'

export default {
  name: 'UsersFormGroup',
  props: {
    value: { type: String, default: '' },
    default: { type: String, default: 'Select...' },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      groups: {},
      isLoading: true,
      select_value: ''
    }
  },
  mounted () {
    // Busca pela lista de grupos
    this.isLoading = true
    API.users.fetchGroups(groups => {
      this.groups = groups
      this.isLoading = false
    })
  },
  computed: {
    defaultValue () {
      return this.default
    }
  },
  watch: {
    value () {
      this.select_value = this.value
    }
  }
}
</script>
